﻿export interface IClcSwapFailure {
     id: number;
     recipientAlias: string;
     swapFailureCount: number;
     clcPoints: number;
}